import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'reactstrap';

// Local Deps
import { Input } from 'antd';

import './SuperAdminHome.scss';
import msgs from '../../config/messages';
import SuperAdminMenu from '../../components/SuperAdminMenu';
import PendingRequest from '../../components/grids/PendingRequest';
import SearchUsers from './SearchUsers/SearchUsers';
import Banner from '../Banner';
import Loading from '../../components/Loading';
import Toast from '../../components/Toaster';
import NFButton from '../../components/primitives/NFButton';

export default class SuperAdminHome extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    auth: PropTypes.object.isRequired,
    selectedMenu: PropTypes.object,
    onMenuClick: PropTypes.func.isRequired,
    requests: PropTypes.any.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onGetGovernmentUsers: PropTypes.func.isRequired,
    onViewOrgSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    email: PropTypes.string.isRequired,
    cage: PropTypes.string.isRequired,
    orgName: PropTypes.string.isRequired,
    orgCage: PropTypes.string.isRequired,
    users: PropTypes.instanceOf(Array).isRequired,
    refreshUsers: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    toastLevel: PropTypes.string.isRequired,
    toastMessage: PropTypes.string.isRequired,
    showToast: PropTypes.bool.isRequired,
    organizationsCage: PropTypes.string.isRequired,
    organizationsName: PropTypes.string.isRequired,
    organizationsStatus: PropTypes.string.isRequired,
    refreshOrganizations: PropTypes.func.isRequired,
    userType: PropTypes.instanceOf(Object).isRequired,
    onHandleUserTypeSwitchChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    selectedMenu: { text: 'View Pending Request', value: 'pendingReqs' },
  };

  render() {
    const {
      isLoading,
      auth,
      selectedMenu,
      onSubmit,
      onGetGovernmentUsers,
      onViewOrgSubmit,
      onMenuClick,
      requests,
      onChange,
      email,
      cage,
      orgName,
      orgCage,
      users,
      refreshUsers,
      loading,
      toastLevel,
      toastMessage,
      showToast,
      organizationsCage,
      organizationsName,
      organizationsStatus,
      refreshOrganizations,
      userType,
      onHandleUserTypeSwitchChange
    } = this.props;

    const getSearchOut = () => {
      let strOut = '';
      if (document.getElementById('email') && document.getElementById('cage')) {
        if (
          document.getElementById('email').value !== '' &&
          document.getElementById('cage').value !== ''
        ) {
          strOut = `Showing results for  ${document.getElementById('cage').value
            }, ${document.getElementById('email').value}`;
        } else if (
          document.getElementById('email').value !== '' &&
          document.getElementById('cage').value === ''
        ) {
          strOut = `Showing results for ${document.getElementById('email').value
            }`;
        } else if (
          document.getElementById('cage').value !== '' &&
          document.getElementById('email').value === ''
        ) {
          strOut = `Showing results for  ${document.getElementById('cage').value
            }`;
        } else {
          strOut = 'Search Users';
        }
      }
      return strOut;
    };

    const clearDivHolder = () => {
      if (document.getElementById('holder')) {
        document.getElementById('holder').innerHTML = '';
      }
    };

    return (
      <div className="nf-account-admin">
        <Row className="nf-account-admin__header">
          {/* <!-- HEADER --> */}
          <Col xs={1} />
          <Col>
            {!organizationsCage && (
              <h1>{selectedMenu.text}</h1>
            )}
            {organizationsCage && (
              <h1>
                <div id="holder" style={{ display: 'block' }}>
                  {
                    // organizationsName},{organizationsCage
                  }
                  {getSearchOut()}
                </div>
              </h1>
            )}
          </Col>
        </Row>
        <Row style={{ flexWrap: 'nowrap' }}>
          <Col xs={2} className="nf-account-admin__side-panel">
            <SuperAdminMenu
              auth={auth}
              onMenuClick={onMenuClick}
              selectedMenu={selectedMenu}
            // govOrgId={govOrgId}
            />

            {selectedMenu.value === 'searchUsers' && (
              <div className="nf-filter-group" style={{ paddingLeft: '6px' }}>
                <h4 className="nf-filter-group__header">
                  Search By Cage Or Email
                </h4>

                <Input
                  style={{ marginBottom: '6px' }}
                  addonBefore="Cage"
                  name="cage"
                  id="cage"
                  // defaultValue=""
                  value={cage}
                  onChange={e => {
                    onChange(e);
                  }}
                />

                <Input
                  addonBefore="Email"
                  name="email"
                  id="email"
                  // defaultValue=""
                  value={email}
                  onChange={e => {
                    onChange(e);
                  }}
                />

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '6px',
                  }}
                >
                  <NFButton
                    className="nf-button--form nf-button--orange w-100"
                    type="submit"
                    onClick={() =>
                      onSubmit(
                        document.getElementById('cage').value,
                        document.getElementById('email').value,
                        userType.isGovernmentUser
                      )
                    }
                  >
                    Submit
                  </NFButton>
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '6px',
                  }}
                >
                  <NFButton
                    className="nf-button--form nf-button--orange w-100"
                    type="submit"
                    onClick={() => {
                      if (userType.isGovernmentUser) return;
                      onGetGovernmentUsers();
                      onHandleUserTypeSwitchChange('governmentUsers', !userType.isGovernmentUser);
                    }
                    }
                  >
                    Government User
                  </NFButton>
                </div>
              </div>
            )}

            {selectedMenu.value === 'viewEntities' && (
              <div className="nf-filter-group" style={{ paddingLeft: '6px' }}>
                <h4 className="nf-filter-group__header">
                  Search By Organization Name or Cage
                </h4>
                <Input
                  style={{ marginBottom: '6px' }}
                  addonBefore="Org Name"
                  name="orgName"
                  id="orgName"
                  value={orgName}
                  onChange={e => {
                    onChange(e);
                  }}
                />

                <br />
                <Input
                  addonBefore="Cage"
                  name="orgCage"
                  id="orgCage"
                  value={orgCage}
                  onChange={e => {
                    onChange(e);
                  }}
                />

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '6px',
                  }}
                >
                  <NFButton
                    className="nf-button--form nf-button--orange"
                    type="submit"
                    onClick={() =>
                      onViewOrgSubmit(
                        document.getElementById('orgName').value,
                        document.getElementById('orgCage').value,
                      )
                    }
                  >
                    Submit
                  </NFButton>
                </div>
              </div>
            )}
          </Col>
          <Col style={{ padding: 0 }}>
            {/* <!-- LOADING --> */}
            {isLoading && <Loading text={msgs.ViewUsers.loading} />}

            {/* <!-- CONTENT --> */}
            {!isLoading && (
              <div className="nf-account-admin__content">
                <Row className="nf-row--justify-end" />
                {/* <!-- Admin Caps Grid --> */}
                <div className="nf-account-admin__grid">
                  {selectedMenu.value === 'searchUsers' && (
                    <SearchUsers
                      loading={loading}
                      refreshUsers={refreshUsers}
                      auth={auth}
                      users={users}
                      organizationsName={organizationsName}
                      organizationsCage={organizationsCage}
                      organizationsStatus={organizationsStatus}
                    />
                  )}

                  {selectedMenu.value === 'pendingReqs' && (
                    <PendingRequest
                      auth={auth}
                      requests={requests}
                      requestType="pending"
                      refreshOrganizations={refreshOrganizations}
                    />
                  )}
                  {/* {selectedMenu.value === 'addOrganization' && (
                    <Registration auth={auth} />
                  )} */}
                  {selectedMenu.value === 'viewEntities' && (
                    <PendingRequest
                      auth={auth}
                      requests={requests}
                      requestType="approved"
                      refreshOrganizations={refreshOrganizations}
                    />
                  )}
                  {selectedMenu.value === 'rejectedReqs' && (
                    <PendingRequest
                      requests={requests}
                      auth={auth}
                      requestType="denied"
                      refreshOrganizations={refreshOrganizations}
                    />
                  )}

                  {selectedMenu.value === 'banner' && (
                    <Banner
                      // requests={requests}
                      auth={auth}
                    // requestType="denied"
                    />
                  )}

                  {selectedMenu.value !== 'banner' &&
                    selectedMenu.value !== 'searchUsers' &&
                    selectedMenu.value !== 'pendingReqs' &&
                    selectedMenu.value !== 'addOrganization' &&
                    selectedMenu.value !== 'viewEntities' &&
                    selectedMenu.value !== 'rejectedReqs' && <div>TBD</div>}
                  {selectedMenu.value !== 'searchUsers' && clearDivHolder()}
                </div>
              </div>
            )}
          </Col>
        </Row>
        <Toast level={toastLevel} message={toastMessage} visible={showToast} />
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SuperAdminHome/SuperAdminHome.jsx